import ReactOnRails from 'react-on-rails';

declare global {
    interface Window {
        ReactOnRails: typeof ReactOnRails
    }
}

window.ReactOnRails = window.ReactOnRails || ReactOnRails;

export default window.ReactOnRails